import React, { useRef, useState } from "react";
import axios from "axios";
import { Upload, Check, AlertTriangle } from "lucide-react";
import { API } from "@/lib/constants";

export function Step1Upload({ t, cvText, setCvText, fileName, setFileName }) {
  const inputRef = useRef(null);
  const [drag, setDrag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleFile = async (file) => {
    if (!file) return;
    setLoading(true);
    setError("");
    try {
      const form = new FormData();
      form.append("file", file);
      const res = await axios.post(`${API}/upload-cv`, form, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setCvText(res.data.text);
      setFileName(res.data.filename);
    } catch (e) {
      setError(e?.response?.data?.detail || t.errors.upload);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="wizard-step-1">
      <h2 className="font-heading font-bold text-3xl lg:text-4xl text-[#292524] mb-2">{t.wizard.s1.title}</h2>
      <p className="text-[#57534E] mb-8">{t.wizard.s1.sub}</p>

      <label
        htmlFor="cv-file"
        className={`dropzone block ${drag ? "drag" : ""}`}
        onDragOver={(e) => { e.preventDefault(); setDrag(true); }}
        onDragLeave={() => setDrag(false)}
        onDrop={(e) => {
          e.preventDefault();
          setDrag(false);
          const f = e.dataTransfer.files?.[0];
          if (f) handleFile(f);
        }}
        data-testid="cv-dropzone"
      >
        <input
          ref={inputRef}
          id="cv-file"
          type="file"
          accept=".pdf,.docx,.txt"
          className="hidden"
          onChange={(e) => handleFile(e.target.files?.[0])}
          data-testid="cv-file-input"
        />
        <Upload className="w-10 h-10 text-[#D95D39] mx-auto mb-4" />
        <div className="font-heading font-semibold text-lg text-[#292524] mb-1">
          {loading ? t.wizard.s1.uploading : t.wizard.s1.drop}
        </div>
        <div className="text-sm text-[#78716C]">{t.wizard.s1.accepted}</div>
        {fileName && !loading && (
          <div className="mt-4 inline-flex items-center gap-2 tag tag-success" data-testid="cv-loaded-tag">
            <Check className="w-3.5 h-3.5" /> {t.wizard.s1.parsed}: {fileName}
          </div>
        )}
      </label>

      {error && (
        <div className="mt-4 text-sm text-[#D9423E] flex items-center gap-2" data-testid="cv-upload-error">
          <AlertTriangle className="w-4 h-4" /> {error}
        </div>
      )}

      <div className="mt-6">
        <div className="overline mb-2">{t.wizard.s1.or}</div>
        <textarea
          className="input"
          placeholder={t.wizard.s1.placeholder}
          value={cvText}
          onChange={(e) => setCvText(e.target.value)}
          data-testid="cv-text-input"
        />
      </div>
    </div>
  );
}
